import { useQuery } from '@tanstack/react-query';
import { Environment } from '../utils/Environment';
import { ONE_HOUR_IN_MS } from 'globalConstants';
import { SHOPLESS_RESELLER_ID } from 'services/analytics/channelInfo';
import { IReseller } from 'services/dcs/bundle';

export const MISSING_RESELLER_ID_ERROR_MSG = 'Missing resellerId. Cannot fetch reseller data.';
export const SHOPLESS_RESELLER_ERROR_MSG = 'Shopless reseller detected. No reseller data available.';

export const fetchReseller = async (resellerId?: string) => {
  if (!resellerId) throw new Error(MISSING_RESELLER_ID_ERROR_MSG);
  if (resellerId === SHOPLESS_RESELLER_ID) throw new Error(SHOPLESS_RESELLER_ERROR_MSG);

  const response = await Environment.current.dcsApiClient.get<IReseller>(`/v1/resellers/${resellerId}`);
  return response.data;
};

export function useDCSReseller(resellerId: string | undefined) {
  const {
    error: getResellerError,
    data: reseller,
    refetch: getReseller,
  } = useQuery(['reseller', resellerId], async () => fetchReseller(resellerId), {
    enabled: !!resellerId,
    staleTime: ONE_HOUR_IN_MS,
  });

  return {
    reseller,
    getResellerError,
    getReseller,
  };
}
